import { PortfolioInformation } from "types/PortfolioInformation";
import { ActionType, getType } from "typesafe-actions";
import * as portfolioInformationActions from "./portfolioInformationActions";

export interface PortfolioInformationState {
  loading?: boolean;
  data?: PortfolioInformation;
  error?: string;
}

export type PortfolioInformationActions = ActionType<
  typeof portfolioInformationActions
>;

export default function portfolioInformation(
  state: PortfolioInformationState = {},
  action: PortfolioInformationActions
) {
  switch (action.type) {
    case getType(portfolioInformationActions.load):
      return { ...state, loading: true };
    case getType(portfolioInformationActions.loadSuccess):
      return {
        ...state,
        loading: false,
        data: action.data,
        error: undefined,
      };
    case getType(portfolioInformationActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
